module.exports = __webpack_public_path__ + "img/DTYLX_zh.9bf09a3a.png";